import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { CreateStyleProvider, CREATE_STYLE } from '@finder/shared/utils/dom/createStyle';


@Directive({
    selector: '[finderPartialBg]',
    standalone: true
})
export class PartialBgDirective implements OnInit {
    private partialEnabled: any;

    @Input()
    set finderPartialBg(data: any) {
        this.partialEnabled = data;
    }

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document,
        @Inject(CREATE_STYLE) private createStyle: CreateStyleProvider,
    ) {}

    ngOnInit() {
        /* istanbul ignore if */
        if (this.partialEnabled !== true) {
            return;
        }

        // Create the element
        const partialBgElem = this.renderer.createElement('div');
        partialBgElem.className = 'partial-bg';

        // Add the element to the DOM
        this.renderer.insertBefore(this.elementRef.nativeElement, partialBgElem, this.elementRef.nativeElement.firstChild);

        // Create the styling
        const css = `
.partial-bg {
    background: var(--partial-bg-background, var(--block-layout-dark-bg-color));
    width: 100%;
    height: var(--partial-bg-height, 200px);
    position: absolute;
    top: var(--partial-bg-top, 50%);
}
`;
        // Add the CSS to the document
        this.createStyle(this.document, css, 'partail-bg');
    }
}
